import Marquee from "react-fast-marquee";
import { useSiteSettings } from "../contexts/SiteSettingsContext";

const StatusMarquee = () => {
    const { settings } = useSiteSettings();

    const hasCustomMessage = settings.customMarqueeMessage && settings.customMarqueeMessage.trim();
    const hasStatusToggle = settings.notAcceptingOrders || settings.websiteUnderMaintenance;

    if (!hasCustomMessage && !hasStatusToggle) {
        return null;
    }

    let message = "";
    let bgColor = "bg-[#008000]";

    if (hasCustomMessage) {
        message = settings.customMarqueeMessage.trim();
        bgColor = settings.notAcceptingOrders ? "bg-red-500" : settings.websiteUnderMaintenance ? "bg-yellow-500" : "bg-[#008000]";
    } else if (settings.notAcceptingOrders) {
        message = "⚠️ We are currently not accepting orders. Please check back later.";
        bgColor = "bg-red-500";
    } else if (settings.websiteUnderMaintenance) {
        message = "🔧 Website is under maintenance. Some features may be unavailable.";
        bgColor = "bg-yellow-500";
    }

    return (
        <div className={`${bgColor} text-white py-1 relative`}>
            <Marquee
                speed={50}
                gradient={false}
                pauseOnHover={true}
            >
                {Array.from({ length: 20 }, (_, i) => (
                    <span key={i} className="mx-6 text-xs sm:text-sm font-medium">{message}</span>
                ))}
            </Marquee>
        </div>
    );
};

export default StatusMarquee;

